export const HRM_ROUTES = {
  HRM_LEGAL_ENTITIES: "/hrm/org/legal-entities",
  HRM_COMPANY_LEVELS: "/hrm/org/company-levels",
  HRM_BUSINESS_LINES: "/hrm/org/business-lines",
  HRM_EMPLOYEE_GROUPS: "/hrm/org/employee-groups",
  HRM_SPECIALTIES: "/hrm/org/specialties",
  HRM_TITLE_GROUPS: "/hrm/org/title-groups",
  HRM_JOB_FAMILIES: "/hrm/org/job-families",
  HRM_JOB_GROUPS: "/hrm/org/job-groups",
  HRM_ORG_LEVELS: "/hrm/org/org-levels",
  HRM_TITLES: "/hrm/org/titles",
  HRM_JOBS: "/hrm/org/jobs",
  HRM_ORG_UNITS: "/hrm/org/org-units",
  HRM_POSITIONS: "/hrm/org/positions",
  HRM_HEADCOUNTS: "/hrm/org/headcounts",
  HRM_NATIONALITIES: "/hrm/hr/nationalities",
  HRM_ETHNICITIES: "/hrm/hr/ethnicities",
  HRM_BANKS: "/hrm/hr/banks",
  HRM_EDUCATION_LEVELS: "/hrm/hr/education-levels",
  HRM_PROFESSIONAL_TITLES: "/hrm/hr/professional-titles",
  HRM_EMPLOYEE_TYPES: "/hrm/hr/employee-types",
  HRM_STANDARD_WORKDAYS: "/hrm/hr/standard-workdays",
  HRM_ATTENDANCE_OBJECTS: "/hrm/hr/attendance-objects",
  HRM_ATTENDANCE_WORK_TYPES: "/hrm/hr/attendance-work-types",
  HRM_ATTENDANCE_SYMBOLS: "/hrm/hr/attendance-symbols",
  HRM_ATTENDANCE_HOLIDAYS: "/hrm/hr/attendance-holidays",
  HRM_ATTENDANCE_SHIFTS: "/hrm/hr/attendance-shifts",
  HRM_ATTENDANCE_SHIFT_SCHEDULES: "/hrm/hr/attendance-shift-schedules",
  HRM_OT_TIME_WINDOWS: "/hrm/hr/ot-time-windows",
  HRM_OT_REASONS: "/hrm/hr/ot-reasons",
  HRM_OT_PLANS: "/hrm/hr/ot-plans",
  HRM_OT_PLAN_LINES: "/hrm/hr/ot-plan-lines",
  HRM_COLLECTIVE_BUSINESS_TRIPS: "/hrm/hr/collective-business-trips",
  HRM_COLLECTIVE_BUSINESS_TRIP_LINES: "/hrm/hr/collective-business-trip-lines",
  HRM_TITLE_POLICIES: "/hrm/hr/title-policies",
  HRM_BIRTHDAY_PLANS: "/hrm/hr/birthday-plans",
  HRM_KEY_BIRTHDAY_PLANS: "/hrm/hr/key-birthday-plans",
  HRM_RELIGIONS: "/hrm/hr/religions",
  HRM_MARITAL_STATUSES: "/hrm/hr/marital-statuses",
  HRM_HEALTHCARE_PLACES: "/hrm/hr/healthcare-places",
  HRM_TRAINING_SCHOOLS: "/hrm/hr/training-schools",
  HRM_STUDY_MAJORS: "/hrm/hr/study-majors",
  HRM_PRACTICE_FORMS: "/hrm/hr/practice-forms",
  HRM_PRACTICE_DURATIONS: "/hrm/hr/practice-durations",
  HRM_DOCTOR_COMPETENCIES: "/hrm/hr/doctor-competencies",
  HRM_OCCUPATIONS: "/hrm/hr/occupations",
  HRM_HOSPITALS: "/hrm/hr/hospitals",
  HRM_HEALTH_STATUSES: "/hrm/hr/health-statuses",
  HRM_HEALTH_EXAM_CLASSIFICATIONS: "/hrm/hr/health-exam-classifications",
  HRM_OCCUPATIONAL_DISEASES: "/hrm/hr/occupational-diseases",
  HRM_FOREIGN_LANGUAGE_LEVELS: "/hrm/hr/foreign-language-levels",
  HRM_COMPUTER_SKILL_LEVELS: "/hrm/hr/computer-skill-levels",
  HRM_WORK_LOCATIONS: "/hrm/hr/work-locations",
  HRM_BUSINESS_TRIP_REASONS: "/hrm/hr/business-trip-reasons",
  HRM_CONTRACT_GROUPS: "/hrm/hr/contract-groups",
  HRM_CONTRACT_TYPES: "/hrm/hr/contract-types",
  HRM_CONSTITUTION_BASES: "/hrm/hr/constitution-bases",
  HRM_DECISION_BASES: "/hrm/hr/decision-bases",
  HRM_DECISION_TYPES: "/hrm/hr/decision-types",
  HRM_ESTABLISHMENT_REASONS: "/hrm/hr/establishment-reasons",
  HRM_ESTABLISHMENT_DECISIONS: "/hrm/hr/establishment-decisions",
  HRM_DIRECTIVE_BASES: "/hrm/hr/directive-bases",
  HRM_DISCIPLINE_FORMS: "/hrm/hr/discipline-forms",
  HRM_RESIGNATION_REASONS: "/hrm/hr/resignation-reasons",
  HRM_REWARD_FORMS: "/hrm/hr/reward-forms",
  HRM_TRAINING_CLASSIFICATIONS: "/hrm/hr/training-classifications",
  HRM_TRAINING_SYSTEMS: "/hrm/hr/training-systems",
  HRM_CLINICAL_SPECIALTIES: "/hrm/hr/clinical-specialties",
  HRM_SPECIALTY_DISEASE_CLASSIFICATIONS: "/hrm/hr/specialty-disease-classifications",
  HRM_SALARY_CHANGE_REASONS: "/hrm/hr/salary-change-reasons",
  HRM_POSITION_CHANGE_REASONS: "/hrm/hr/position-change-reasons",
  HRM_TECHNICAL_SPECIALTIES: "/hrm/hr/technical-specialties",
  HRM_DMKT_REGISTRATION_CAMPAIGNS: "/hrm/hr/dmkt-registration-campaigns",
  HRM_CERTIFICATES: "/hrm/hr/certificates",
  HRM_DIPLOMAS: "/hrm/hr/diplomas",
  HRM_HEALTH_RECORDS: "/hrm/hr/health-records",
  HRM_PROCEDURE_DOSSIERS: "/hrm/hr/procedure-dossiers",
  HRM_EVALUATION_RECORDS: "/hrm/hr/evaluation-records",
  HRM_ONBOARDING_RECORDS: "/hrm/hr/onboarding-records",
  HRM_JOB_DESCRIPTION_RECORDS: "/hrm/hr/job-description-records",
  HRM_TRAINING_HISTORIES: "/hrm/hr/training-histories",
  HRM_CONTRACTS: "/hrm/hr/contracts",
  HRM_WORK_HISTORIES: "/hrm/hr/work-histories",
  HRM_SALARY_DECISIONS: "/hrm/hr/salary-decisions",
  HRM_FAMILY_RELATIONS: "/hrm/hr/family-relations",
  HRM_LEAVE_RECORDS: "/hrm/hr/leave-records",
  HRM_DISCIPLINE_HISTORIES: "/hrm/hr/discipline-histories",
  HRM_REWARD_HISTORIES: "/hrm/hr/reward-histories",
  HRM_BUSINESS_TRIPS: "/hrm/hr/business-trips",
  HRM_MATERNITY_HISTORIES: "/hrm/hr/maternity-histories",
  HRM_CONCURRENT_ROLES: "/hrm/hr/concurrent-roles",
  HRM_SOCIAL_INSURANCE_HISTORIES: "/hrm/hr/social-insurance-histories",
  HRM_END_CONCURRENT_ROLES: "/hrm/hr/end-concurrent-roles",
  HRM_LATE_EARLY_REGIMES: "/hrm/hr/late-early-regimes",
  HRM_SUPPLEMENTAL_LEAVE_GRANTS: "/hrm/hr/supplemental-leave-grants",
  HRM_LEAVE_YEAR_BALANCES: "/hrm/hr/leave-year-balances",
  HRM_LEAVE_BALANCES: "/hrm/portal/leave-balances",
  HRM_COMPENSATORY_LEAVE_GRANTS: "/hrm/hr/compensatory-leave-grants",
  HRM_PRACTICE_CERTIFICATES: "/hrm/hr/practice-certificates",
  HRM_PERIODIC_HEALTH_EXAMS: "/hrm/hr/periodic-health-exams",
  HRM_HEPATITIS_B_VACCINATIONS: "/hrm/hr/hepatitis-b-vaccinations",
  HRM_COOPERATIONS: "/hrm/hr/cooperations",
  HRM_WORK_ACCIDENTS: "/hrm/hr/work-accidents",
  HRM_EMPLOYEE_FILES: "/hrm/hr/employee-files",
  HRM_OCCUPATIONAL_DISEASE_CASES: "/hrm/hr/occupational-disease-cases",
  HRM_PRACTICE_MENTORSHIPS: "/hrm/hr/practice-mentorships",
  HRM_PRACTICE_GUIDANCE_ACTIVE: "/hrm/hr/practice-guidance-active",
  HRM_PRACTICE_MENTOR_ELIGIBILITY: "/hrm/hr/practice-mentor-eligibility",
  HRM_SALARY_PROPOSALS: "/hrm/hr/salary-proposals",
  HRM_TECHNICAL_COMPETENCIES: "/hrm/hr/technical-competencies",
  HRM_LEAVE_CARRYOVER_EXTENSIONS: "/hrm/hr/leave-carryover-extensions",
  HRM_REGIONAL_MINIMUM_WAGES: "/hrm/hr/regional-minimum-wages",
  HRM_SI_PARTICIPATION_RATES: "/hrm/hr/si-participation-rates",
  HRM_ATTENDANCE_PERIODS: "/hrm/hr/attendance-periods",
  HRM_PAYROLL_PERIODS: "/hrm/hr/payroll-periods",
  HRM_PAYROLL_ITEM_GROUPS: "/hrm/hr/payroll-item-groups",
  HRM_PAYROLL_ITEMS: "/hrm/hr/payroll-items",
  HRM_PAYROLL_ITEM_FORMULAS: "/hrm/hr/payroll-item-formulas",
  HRM_SI_MONTHLY_CONTRIBUTIONS: "/hrm/hr/si-monthly-contributions",
  HRM_EXTERNAL_INCOME_INDIVIDUALS: "/hrm/hr/external-income-individuals",
  HRM_EXTERNAL_INCOME_BLOCKS: "/hrm/hr/external-income-blocks",
  HRM_SALARY_PLAN_ENTRIES: "/hrm/hr/salary-plan-entries",
  HRM_CLASSIFIED_REVENUES: "/hrm/hr/classified-revenues",
  HRM_KY1_BENEFIT_RATES: "/hrm/hr/ky1-benefit-rates",
  HRM_HOSPITAL_MONTHLY_REVENUES: "/hrm/hr/hospital-monthly-revenues",
  HRM_DUTY_CONVERSION_ENTRIES: "/hrm/hr/duty-conversion-entries",
  HRM_TIMESHEET_DAILY_ENTRIES: "/hrm/hr/timesheet-daily-entries",
  HRM_LATE_EARLY_VIOLATIONS: "/hrm/hr/late-early-violations",
  HRM_DUTY_FUND_LEDGERS: "/hrm/hr/duty-fund-ledgers",
  HRM_COMP_LEAVE_FUND_LEDGERS: "/hrm/hr/comp-leave-fund-ledgers",
  HRM_FUND_OPENING_BALANCES: "/hrm/hr/fund-opening-balances",
  HRM_PAYROLL_SNAPSHOTS: "/hrm/hr/payroll-snapshots",
  HRM_LEAVE_REQUESTS: "/hrm/portal/leave-requests",
  HRM_LEAVE_REQUEST_APPROVAL_STEPS: "/hrm/portal/leave-request-approval-steps",
  HRM_BUSINESS_TRIP_REQUESTS: "/hrm/portal/business-trip-requests",
  HRM_OT_REQUESTS: "/hrm/portal/ot-requests",
  HRM_OT_REQUEST_APPROVAL_STEPS: "/hrm/portal/ot-request-approval-steps",
  HRM_OT_REQUEST_EDIT_EVENTS: "/hrm/portal/ot-request-edit-events",
  HRM_REQUEST_ATTACHMENTS: "/hrm/portal/request-attachments",
  HRM_PORTAL_TIMESHEET_DAILY_ENTRIES: "/hrm/portal/timesheet-daily-entries",
  HRM_ATTENDANCE_EXPLANATION_REQUESTS: "/hrm/portal/attendance-explanation-requests",
  HRM_DMKT_REGISTRATION_REQUESTS: "/hrm/portal/dmkt-registration-requests",
  HRM_DMKT_REGISTRATION_LINES: "/hrm/portal/dmkt-registration-lines",
  HRM_DMKT_REGISTRATION_APPROVAL_STEPS: "/hrm/portal/dmkt-registration-approval-steps",
  HRM_DMKT_REGISTRATION_EDIT_EVENTS: "/hrm/portal/dmkt-registration-edit-events",
  HRM_RESIGNATION_REQUESTS: "/hrm/portal/resignation-requests",
  HRM_ALERTS: "/hrm/hr/alerts",
  HRM_FORM_LAYOUTS: "/hrm/hr/form-layouts",
  HRM_REPORT_LAYOUTS: "/hrm/hr/report-layouts",
  HRM_ABR_PHASE: "/hrm/hr/abr-phase",
  HRM_AD_LDAP: "/hrm/integrations/ad-ldap",
  HRM_WEBHOOKS: "/hrm/integrations/webhooks",
  HRM_HIS_REVENUE: "/hrm/integrations/his-revenue",
  HRM_NFR_SECURITY: "/hrm/integrations/nfr-security",
  HRM_EMPLOYEES: "/hrm/hr/employees",
} as const;

export type HrmRouteKey = keyof typeof HRM_ROUTES;
